export default __webpack_public_path__ + "e16832068ce054f4d5e67c522d87d099.svg";